<template>
    <div class="site__body site__body-order-entry">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">
                                            Home
                                        </router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--last">
                                        <a href="#" class="breadcrumb__item-link">Return Items</a>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>

                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Return Items</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="container">
                    <div class="">
                        
                        
                        <div class="widget-form-panel-mobile">
                            <div><strong>Customer:</strong> {{ billingdetails.billingname }}</div>
                            <div><strong>City/State:</strong> {{ billingdetails.billingcity + ', ' + billingdetails.billingstate}}</div>
                            <div><strong>Contact Phone:</strong>  {{billingdetails.billingphone}}</div>
                            <div class="block-space--layout--divider-order-entry"></div>
                            <div class="container-form">
                                <div class="container-form-button">
                                    <button type="button" class="btn btn-xs btn-grey" @click="expand">Expand Form</button>
                                </div>
                            </div>
                        </div>

                        <div class="cart__table cart-table">
                            <return-items-list
                                ref="itemList"
                                @update_po="update_po"
                                @submitted="submitted">
                            </return-items-list>
                        </div>
                    </div>

                    <div></div>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-order-entry"></div>
    </div>
    <div class="block-space block-space--layout--divider-thin"></div>
    <div class="block-space block-space--layout--divider-XS"></div>
    <br />
    <br />

    <base-dialog :title="savedResp.title" @close="savedResp.show = false" :open="savedResp.show">
        <template #default>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <p>
                        {{savedResp.message}}
                    </p>
                </div>
            </div>
        </template>
        <template #actions>
        
        <button type="button" class="btn btn-sm btn-primary" @click="savedResp.show = false">
            OK
        </button>
        </template>
    </base-dialog>
</template>

<script>
import ReturnItemsList from './ReturnItemsList.vue';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from "vuex";

export default {
    components: {
        ReturnItemsList
    },
    data() {
        return {
            formData: {
                reason: '',
                retPO: '',
                email: '',
                savedDRMA: ''
            },

            savedResp: {
                title: '',
                show: false,
                message:  ''
            },

            reasons:  [],
            customerInfo: {
                billingname: '',
                billingcity: '',
                billingstate: '',
                billingphone: '',
            },
        };
    },
    methods: {
        rmaEnabled(){
            const isEnabled = this.$store.getters['rma_enabled'];
            // const isEnabled = 'N';

            if(isEnabled == 'Y'){
                this.$router.push('/return-items');
            }
        },

        /** fetch reasons from web service */
        fetchNonRMAReasons() {
            const return_nonrma_reasons_uri = this.$store.getters['api/return_nonrma_reasons_uri'];
            axiosvl.post(return_nonrma_reasons_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        },
                    }
                }
            )
            .then((response) => {
                const REASONS = response.data.webroutine.lists.NONRMAREASONS.entries;
                this.reasons = [];

                for (const key in REASONS) {
                    const obj = REASONS[key];
                    
                    this.reasons.push({
                        code: obj.RSREAS,
                        description: obj.RSDESC,
                    });
                }
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        submitted(resultmsg) {
            this.savedResp = resultmsg;
        },

        expand() {
            this.$refs.itemList.expand();
        },
        update_email(email) {
            this.formData.email = email;
        },
        update_reference(savedDRMA) {
            this.formData.savedDRMA = savedDRMA;
        },
        update_po(retPO) {
            this.formData.retPO = retPO;
        },
    },
    computed: {
        ...mapGetters('cart', [
        "billingdetails"
        ])
    },
    created(){
        this.rmaEnabled();
    },

    updated() {
        // this.customerInfo = this.$store.getters['cart/billingdetails'];
    },

    mounted() {
        this.fetchNonRMAReasons();
        console.log(this.billingdetails);
    }
}
</script>